import React from 'react';
import { ConfigProvider, Tabs } from 'antd';
import { useFaqData } from './components/FAQ/useFAQData';

const FaqPage = () => {
  const faqData = useFaqData();
  const TABS_DATA = faqData.getTabsData();
  const onChange = key => {
    console.log(key);
  };
  return (
    <main>
      <div className="container" style={{ maxWidth: '1130px' }}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#88442e',
              fontSize: 16,
            },
          }}
        >
          <Tabs items={TABS_DATA} onChange={onChange} />
        </ConfigProvider>
      </div>
    </main>
  );
};

export default FaqPage;
